import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ZONES } from '@finxone-platform/shared/sys-config-types';
import { KeycloakService } from 'keycloak-angular';
import { AccountService } from '../../services/account-service/account-service.service';
import { DeviceTypeService } from '../../services/device-type/device-type.service';
import { formatNameAsUrl } from '../../utils/zone-url.utils';
import {
  checkTokensInStorageOrWindow,
  getTokenFromStorageOrWindow,
} from '@app/finxone-web-frontend/app/lib/utils/auth-checks.utils';
import * as Sentry from '@sentry/angular';
import { waitForFlutterWebView } from '@app/finxone-web-frontend/app/lib/utils/flutter.utils';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  constructor(
    protected keycloakService: KeycloakService,
    private _router: Router,
    private accountService: AccountService,
    private deviceTypeService: DeviceTypeService,
  ) {
    if (checkTokensInStorageOrWindow()) {
      this.accountService.setRoleInfo(getTokenFromStorageOrWindow() as string);
      this._router.navigateByUrl('/feature-redirect');
    } else {
      if (this.deviceTypeService.currentdeviceType == 'desktop') {
        this.keycloakService.login({
          redirectUri: window.location.origin,
        });
      } else {
        waitForFlutterWebView().then((flutterWebView) => {
          if (flutterWebView) {
            flutterWebView
              .callHandler('getRememberMeUsername', [])
              .then((username: null | string) => {
                if (username) {
                  console.log('LoginComponent flutterWebView RememberMeUsername found - go to login');
                  this.keycloakService.login({
                    redirectUri: window.location.origin + '/feature-redirect',
                    loginHint: username,
                  });
                } else {
                  console.log('LoginComponent flutterWebView RememberMeUsername not found - redirect');
                  this.mobileRedirect();
                }
              })
              .catch(() => {
                console.error('Failed to fetch username from mobile app');
                this.mobileRedirect();
              });
          } else {
            this.mobileRedirect();
          }
        });
      }
    }
  }

  private mobileRedirect() {
    const firstTime: string | null = localStorage.getItem('firstTime');
    Sentry.addBreadcrumb({
      category: 'Web Frontend - Login Process',
      message: 'LoginComponent mobileRedirect',
      level: 'info',
      data: {
        firstTime: firstTime,
      },
    });
    Sentry.captureSession();
    console.log('LoginComponent mobileRedirect, firstTime:', firstTime);
    if (firstTime == null) {
      localStorage.setItem('firstTime', 'true');
      this._router.navigate(['zones', formatNameAsUrl(APP_ZONES.SIGNED_OUT_FIRST_INTRODUCTION)]);
      return;
    }
    this._router.navigate(['zones', formatNameAsUrl(APP_ZONES.SIGNED_OUT_INTRODUCTION)]);
  }
}
